import { useOktaAuth } from '@okta/okta-react';
import { oktaLogin, isOktaAuthenticated } from '../utils/okta_auth';
import { useDispatch } from 'react-redux';
import { loginUser, logoutUser } from '../store/slices/authSlice';
import { useEffect } from 'react';

export const useOkta = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const dispatch = useDispatch();

  // Effect to handle authentication state changes
  useEffect(() => {
    if (authState && isOktaAuthenticated(authState)) {
      // When user is authenticated, set up auth and RBAC
      const accessToken = authState.accessToken?.accessToken;
      if (accessToken) {
        dispatch(
          loginUser({
            user: authState.idToken?.claims,
            token: accessToken,
          })
        );
      }
    } else if (authState && !isOktaAuthenticated(authState)) {
      // When user is not authenticated, clear auth and RBAC state
      dispatch(logoutUser());
    }
  }, [authState, dispatch]);

  async function authenticate() {
    if (!authState) {
      return;
    }

    if (!isOktaAuthenticated(authState)) {
      oktaLogin(oktaAuth);
    }
  }

  return {
    authState,
    authenticate,
  };
};
